var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-approve",
    transform: "translate(3982 -530)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1206",
    "data-name": "Rectangle 1206",
    width: 36,
    height: 36,
    rx: 4,
    transform: "translate(-3982 530)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "certificate-check",
    transform: "translate(-3976.25 534.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6906",
    "data-name": "Path 6906",
    d: "M6.75,18h4.286v1.429H6.75Z",
    transform: "translate(-0.611 -3.897)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6907",
    "data-name": "Path 6907",
    d: "M6.75,13.5h7.143v1.429H6.75Z",
    transform: "translate(-0.611 -2.254)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6908",
    "data-name": "Path 6908",
    d: "M6.75,9h7.143v1.429H6.75Z",
    transform: "translate(-0.611 -0.611)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "M10.821,20.214H3.679V5.929H20.821v7.143H22.25V5.929A1.429,1.429,0,0,0,20.821,4.5H3.679A1.429,1.429,0,0,0,2.25,5.929V20.214a1.429,1.429,0,0,0,1.429,1.429h7.143Z",
    transform: "translate(0)",
    fill: "#213364"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "M23.107,26.082l-1.85-1.85L20.25,25.239,23.107,28.1l5.714-5.714-1.007-1.007Z",
    transform: "translate(-6.571 -6.161)",
    fill: "#213364"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprove);
export default __webpack_public_path__ + "static/media/icon-approve.c0d5b2bb664b930108f7946557679f58.svg";
export { ForwardRef as ReactComponent };